var pageSettings = {
    pageContentBgTransparent: false,
    pageContentBrandGradient: false,
    pageWithoutFooter: false,
    pageEmpty: false,
    pageSidebar: true,
    module: ''
};

export default pageSettings;